import './map.sass';

export default {
	name: 'Map',

	props: {
		offices: {
			type: Array,
			required: true
		},
		dealerType: {
			type: String,
			required: true
		}
	},

	data() {
		return {
			mapProps: '',
			isMapInitialized: false,
			isFullscreen: false,
		};
	},

	watch: {
		offices() {
			this.$nextTick(() => {
				this.buildMap();
			})
		}
	},

	mounted() {
		ymaps.ready(() => {
			this.mapProps = new ymaps.Map('map', {
				center: [55.73, 37.75],
				zoom: 6,
				controls: ['fullscreenControl', 'zoomControl']
			}, {
				suppressMapOpenBlock: true
			}),
			this.isMapInitialized = true;
			this.map = false;
			this.buildMap();
		});
	},

	methods: {
		buildMap() {
			this.mapProps.geoObjects && this.mapProps.geoObjects.removeAll();
			let placemarks = [];
			if(this.dealerType === 'TECE') {
				this.offices && this.offices.length ? placemarks = this.offices : placemarks = [];
			} else {
				let acc = [];
				acc = this.offices.filter(item => item.OFFICES).map(item => item.OFFICES).flat();
				acc && acc.length ? placemarks = acc.filter(item => item.PROPERTIES.YAMAP_OFFICE[0]) : placemarks = [];
			}
			let	collection = new ymaps.GeoObjectCollection(null, {
					iconLayout: 'default#image',
					iconImageHref: '/local/js/img/icons/map-pin.svg',
					iconImageOffset: [-15, -38]
				}),
				coords = placemarks.map(item => {
					return item.PROPERTIES.YAMAP_OFFICE;
				});
			for (var i = 0, l = coords.length; i < l; i++) {
				collection.add(new ymaps.Placemark(coords[i], {
					balloonContentBody: `
						<div class="balloon-body">
							<p class="balloon-body__header">${placemarks[i].NAME}</p>
							<p class="balloon-body__notice">${placemarks[i].PROPERTIES.TYPE_OFFICE.VALUE_ENUM}</p>
							<p class="balloon-body__text">${placemarks[i].PROPERTIES.STATE_OFFICE.VALUE}, ${placemarks[i].PROPERTIES.CITY_OFFICE.VALUE}, ${placemarks[i].PROPERTIES.STREET_OFFICE.VALUE}</p>
							<div class="balloon-body__contacts">
								<a class="balloon-body__link" href="tel:${placemarks[i].PROPERTIES.PHONE_OFFICE.VALUE}">${placemarks[i].PROPERTIES.PHONE_OFFICE.VALUE}</a>
								
								${(placemarks[i].site) ? `<a class="balloon-body__link balloon-body__link--outside" href="${placemarks[i].site}" target="_blank">
									Перейти на сайт
										<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M3.29289 10.2929L2.58579 11L4 12.4142L4.70711 11.7071L3.29289 10.2929ZM14.7071 1.70711C15.0976 1.31658 15.0976 0.683417 14.7071 0.292893C14.3166 -0.0976311 13.6834 -0.0976311 13.2929 0.292893L14.7071 1.70711ZM4.70711 11.7071L14.7071 1.70711L13.2929 0.292893L3.29289 10.2929L4.70711 11.7071Z" fill="#838DAA"/>
										<path d="M14 10V1H5" stroke="#838DAA" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
										<path d="M1 15L15 15" stroke="#838DAA" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
										</svg>
									</a>` : ''}
							</div>
						</div>`,
				}));
			}
			this.mapProps.geoObjects.add(collection);
			const collectionBounds = collection.getBounds();
			if (collection.getLength() === 1) {
				this.mapProps.setCenter(collectionBounds[0], 17)
			} else {
				this.mapProps.setBounds(collectionBounds, {
					checkZoomRange: true,
					zoomMargin: 16
				});
			}
		},
	},

	template: `
		<div class="yandex-map">
			<div class="loader" v-if="!isMapInitialized"></div>
			<div id="map" class="map" />
		</div>	
	`
};
